/* Turns the last visible product tile in each product-list into an elegant
   greyed "Sjá allt" (see all) link: just a faded bottle/can + See-all + count.
   Follows the ACTIVE filter tab: link + count come from the tab's collection
   (data-pl-url / data-pl-count = number of AVAILABLE products), falling back to
   the section's base collection. Skipped when every available product of the
   active tab is already visible (nothing more to see), so small categories
   never lose a product behind the tile.
   Re-marks after the filter/sort JS re-renders (pl:rendered). */
(function () {
  'use strict';
  if (window.__olfSeeAllInit) return;
  window.__olfSeeAllInit = true;

  function buildOverlay(url, count) {
    var a = document.createElement('a');
    a.className = 'pl-seeall__ov';
    a.href = url;
    a.setAttribute('data-seeall-url', url);
    a.setAttribute('aria-label', 'Sjá allt');
    var countHtml = (count > 0)
      ? '<span class="pl-seeall__count">+' + count + '</span>'
      : '';
    a.innerHTML =
      '<span class="pl-seeall__ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg></span>' +
      '<span class="pl-seeall__txt">Sjá allt</span>' +
      countHtml;
    return a;
  }

  // Target of the tile: the active filter tab's collection, else the section's.
  function target(root) {
    var url = root.getAttribute('data-pl-seeall');
    var count = parseInt(root.getAttribute('data-pl-seeall-count'), 10);
    var tab = root.querySelector('.pl-tab.is-active[data-pl-row="filter"]');
    if (tab && tab.getAttribute('data-pl-filter') !== 'all') {
      var tu = tab.getAttribute('data-pl-url');
      var tc = parseInt(tab.getAttribute('data-pl-count'), 10);
      if (tu) { url = tu; count = isNaN(tc) ? 0 : tc; }
    }
    return { url: url, count: isNaN(count) ? 0 : count };
  }

  function clearMarks(items) {
    items.forEach(function (it) {
      if (it.classList.contains('pl-seeall')) {
        it.classList.remove('pl-seeall');
        var old = it.querySelector('.pl-seeall__ov');
        if (old) old.remove();
      }
    });
  }

  function apply(root) {
    if (!root.getAttribute('data-pl-seeall')) return;
    var t = target(root);
    if (!t.url) return;
    var items = Array.prototype.slice.call(root.querySelectorAll('.resource-list__item'));
    if (!items.length) return;
    // Visible tiles (skip cards hidden by a filter or the mobile cap).
    var visible = [];
    items.forEach(function (it) { if (!it.hidden && it.offsetParent !== null) visible.push(it); });
    var last = visible.length ? visible[visible.length - 1] : null;
    // Everything the collection has is already on screen → no "see all" tile
    // (otherwise it would cover the last real product).
    if (!last || (t.count > 0 && visible.length >= t.count)) { clearMarks(items); return; }
    // Already marked correctly (same tile, same target) → leave the DOM alone.
    if (last.classList.contains('pl-seeall')) {
      var ov = last.querySelector('.pl-seeall__ov');
      if (ov && ov.getAttribute('data-seeall-url') === t.url &&
          root.querySelectorAll('.resource-list__item.pl-seeall').length === 1) return;
    }
    clearMarks(items);
    last.classList.add('pl-seeall');
    last.appendChild(buildOverlay(t.url, t.count));
  }
  function applyAll() {
    document.querySelectorAll('[data-pl-seeall]').forEach(apply);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyAll);
  else applyAll();
  window.addEventListener('load', applyAll);
  // Width changes only: mobile browsers fire `resize` whenever the address/tool bar
  // shows or hides (height only), which must not re-mark the tiles.
  var lastW = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastW) return;
    lastW = window.innerWidth;
    clearTimeout(window.__olfSeeAllRz);
    window.__olfSeeAllRz = setTimeout(applyAll, 200);
  });
  document.addEventListener('pl:rendered', function () { requestAnimationFrame(applyAll); });
  document.addEventListener('shopify:section:load', applyAll);
})();
